class Pessoa {
  constructor() {
    this.id = ''
    this.idCliente = ''
    this.idUsuario = ''
    this.tipo = ''
    this.documento = ''
    this.nome = ''
    this.nomeFantasia = ''
    this.tipoLogradouro = ''
    this.logradouro = ''
    this.numero = ''
    this.complemento = ''
    this.bairro = ''
    this.cep = ''
    this.municipioCodigoIbge = ''
    this.municipioNome = ''
    this.estadoCodigoIbge = ''
    this.estadoNome = ''
    this.estadoSigla = ''
    this.paisCodigoIbge = ''
    this.paisNome = ''
    this.inscEstadual = ''
    this.inscMunic = ''
    this.email = ''
    this.site = ''
    this.telefone = ''
    this.celular = ''
    this.rg = ''
    this.dataHora = ''
    this.version = ''
    this.dataVigenciaInicial = ''
    this.dataVigenciaFinal = ''
    this.idFichaRespostaPai = ''
    this.idFluxoInstanciaAtividade = ''

    this.detail = ''
    
    // Joins...
    this.idContribuinte = null
    this.idContribuintePai = null
  }
}

export default Pessoa
